
export class EntityModificationTrace {
act: string;
clas: number | null;
id: number | null;
key: string;
l: number | null;
mkey: string;
rn: number | null;
scen: string;
ts: number | null;
v: string;
}

